import {
  Component,
  Input,
  OnInit,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router } from "@angular/router";
import * as $ from "jquery";
import { DataService } from "../_services/data.service";
import { autoFillForms } from "../_helpers/auto-fill-forms/auto-fill-forms";
import {
  FREE_TEXT_ANSWER_COUNTER_FROM,
  getAnswerLength,
  isAnswerTooLong,
  MAX_FREE_TEXT_ANSWER_LENGTH,
} from "../_helpers/free-text-answer-limit";
import { TranslationService } from "../_services/translation.service";
import { ITranslations } from "../_models/ITranslations";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "questions",
  templateUrl: "./questions.component.html",
  styleUrls: ["./questions.component.scss"],
})
export class QuestionsComponent implements OnInit {
  @Input() event: any;
  @Input() child: any;
  @Input() type: number;
  @Output() checkoutAction: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild("f") f: ElementRef;
  @ViewChild("questionsComponentRoot")
  questionsComponentRoot: ElementRef;
  model: any = {};
  readonly maxAnswerLength = MAX_FREE_TEXT_ANSWER_LENGTH;
  public translations$: Observable<ITranslations>;
  loading0 = false;
  loading1 = false;
  loading2 = false;

  readonly types = {
    fromHome: 0,
    fromModal: 1,
    fromPayments: 2,
  };

  constructor(
    private router: Router,
    private dataService: DataService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
    autoFillForms(this, { shouldSubmit: false });
  }

  //0 - desc, 1 - check, 2 - multi
  public getType(question) {
    if (question.answers && question.answers.length > 0) {
      return question.answers.length == 1 ? 1 : 2;
    } else {
      return 0;
    }
  }

  isTooLong(question) {
    // answers shown from a past payment are read-only and already saved
    if (this.type == this.types.fromPayments) return false;
    return isAnswerTooLong(this.model[question.questionText]);
  }

  answerLength(question) {
    return getAnswerLength(this.model[question.questionText]);
  }

  showCounter(question) {
    return (
      this.type != this.types.fromPayments &&
      this.answerLength(question) >= FREE_TEXT_ANSWER_COUNTER_FROM
    );
  }

  isValid(type, question) {
    if (type == 0)
      return (
        this.model[question.questionText] &&
        this.model[question.questionText] != "" &&
        !this.isTooLong(question)
      );
    else if (type == 1) {
      return this.model[question.questionText];
    } else if (type == 2) {
      return (
        this.model[question.questionText] &&
        this.model[question.questionText].answerId &&
        this.model[question.questionText].answerId > 0
      );
    } else return false;
  }

  equals(l1: any, l2: any) {
    if (!l1 && !l2) return true;
    if (l1 && l1.answerId && l2 && l2.answerId)
      return l1.answerId === l2.answerId;
    else return false;
  }
  /* types : 1 - harshama mahira , 2 - hosafa ke sal ha eruim*/
  addToCart(type) {
    this.setLoader(type, true);
    if (!this.child || this.event.shouldUpdate) {
      this.dataService.updateCart(this.event).subscribe((data) => {
        this.setLoader(type, false);
        this.navigateOnFinish(type);
      });
    } else {
      this.event.submittedQuestions = this.model ? this.model : [];
      this.event.childId = this.child.childId;
      this.event.firstName = this.child.firstName;
      this.event.lastName = this.child.lastName;
      this.event.isInCart = !this.event.isProduct;
      this.event.shouldUpdate = true;
      this.dataService.addToCart(this.event).subscribe((data) => {
        this.setLoader(type, false);
        this.navigateOnFinish(type);
      });
    }
  }

  navigateOnFinish(type) {
    //checkout
    if (type == 1) {
      this.checkoutAction.emit();
    } else {
      this.router.navigate(["/"]);
      if (this.type != this.types.fromModal) {
      } else $("#closeModal").click();
    }
  }

  setLoader(type, value) {
    if (type == 0) this.loading0 = value;
    else if (type == 1) this.loading1 = value;
    else if (type == 2) this.loading2 = value;
  }

  optionClicked(type) {
    if (type == 3 && this.child && this.event) {
      $("#closeModal").click();
      this.router.navigate([
        "/event/" + this.child.childId + "/" + this.event.eventId,
      ]);
    } else {
      if (this.f && this.f["form"] && this.f["form"].valid) {
        this.addToCart(type);
      } else {
        setTimeout(function () {
          let current = $(".modal-body").scrollTop();
          let fromCurrent = $(".has-error").eq(0).parent().offset().top;
          let dist = current + fromCurrent - 550;
          //     			$('.has-error').eq(0).parent().scroll();
          $(".modal-body").animate(
            {
              scrollTop: dist,
            },
            700
          );
        }, 400);
      }
    }
  }

  //   answerQuestions(){
  //   this.addToCart();
  //   }

  ngOnInit() {
    if (this.event && this.event.submittedQuestions) {
      this.model = this.event.submittedQuestions;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cart/questions.component.ts